import { render } from "./envelopesCenter.vue?vue&type=template&id=7f4ac60a&scoped=true"
import script from "./envelopesCenter.vue?vue&type=script&lang=js"
export * from "./envelopesCenter.vue?vue&type=script&lang=js"

import "./envelopesCenter.vue?vue&type=style&index=0&id=7f4ac60a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f4ac60a"]])

export default __exports__